<template>
    <span>
        <el-popover
            ref="popover"
            placement="bottom"
            width="450"
            @show="initData"
            @hide="saveSearch"
            trigger="manual"
            v-model='showPopover'
        >
            <el-tabs
                v-model="activeName"
                class="demo-tabs"
                @tab-click="updatePopover"
            >
                <el-tab-pane
                    label="搜索条件"
                    name="first"
                    v-if="searchTotalTitle.length > 0"
                >
                    <div id="search-set-v2">
                        <div>
                            <el-row class="search-total-box" @drop.native="e=>e.preventDefault()"
                                @dragover.native="(e)=>(e.preventDefault())" >
                                <el-col :span="24">
                                    拖拽可移动选中控件, 点击可切换控件隐藏
                                </el-col>
                                <el-col
                                    class="relative"
                                    :span="6"
                                    v-for="(item, index) in searchTotalTitle"
                                    :key="index"

                                >
                                    <el-button
                                        :class="['search-list-btn btn-width overflow-text', item.select || item.unfold ? 'is-select' : 'is-unselect']"
                                        plain
                                        :title="item.name"
                                        :disabled="item.unfold"
                                        @click="btnChange(index, item)"
                                        :draggable="item.select && !item.unfold"
                                        @dragstart.native="handleItemDragStart($event, item, index)"
                                        @dragend.native="handleItemDragEnd($event)"
                                        @dragenter.native="handleItemDragEnter($event, item, index)"
                                    >{{ item.name }}</el-button>
                                    <template v-if="!item.unfold">
                                        <i
                                            class="btn-icon el-icon-error"
                                            @click="btnChange(index, item)"
                                            v-if="item.select || item.unfold"
                                        ></i>
                                        <i
                                            class="btn-icon el-icon-circle-plus"
                                            @click="btnChange(index, item)"
                                            v-else
                                        ></i>
                                    </template>
                                </el-col>
                            </el-row>
                            <div class="btn-box">
                                <!-- <el-button
                                    type="text"
                                    @click="cancelSearch"
                                >
                                    {{ $translate('component.E202006152345', {
                defaultText: '取消'
            }) }}
                                </el-button> -->
                                <el-button
                                    @click="resetSearchConfig"
                                >                               重置
                                </el-button>
                                <div class="flex-1"></div>
                                <el-button
                                    type="primary"
                                    @click="saveSearch"
                                >
                                    {{ $translate('component.E202006152346', {
                                        defaultText: '保存'
                                    }) }}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane
                    label="列配置"
                    name="second"
                >
                    <slot name='column-config'></slot>
                </el-tab-pane>
            </el-tabs>

            <advance-dialog
                ref="advanceDialog"
                @confirm="detaliSearchSure"
            ></advance-dialog>
            <advance-multi-dialog
                ref="advanceMultiDialog"
                @confirm="detaliListSearchSure"
                @getCheckedList="detailCheckedList"
            ></advance-multi-dialog>
            <advance-user
                ref='advanceUser'
                @confirm="detaliSearchSure"
            ></advance-user>
            <template v-slot:reference>
                <el-tooltip
                    class="item"
                    effect="dark"
                    :content="searchTotalTitle.length? '设置' : '列配置'"
                    placement="bottom"
                >
                    <el-button
                        size="mini"
                        class="el-icon-setting"
                        @click="showPopover = !showPopover;"
                    ></el-button>
                </el-tooltip>
            </template>
        </el-popover>
        <div
            class="search-set_back"
            v-show="showPopover"
            @click.self="showPopover = !showPopover;"
        ></div>
    </span>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import _ from '@/components/lots/utils';
import { longRange, dict, getList } from '../api';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import advanceUser from '@/components/lots/otpAdvanceUser';
import addressSelect from '@/components/lots/otpCascader2';
import { I18nMixins } from '@/components/utils/i18n';
import preventClick from '@/components/utils/directive';
import addressCascader from '@/components/lots/addressCascader';
export default {
    mixins: [I18nMixins, preventClick],
    components: { advanceDialog, addressSelect, advanceUser, addressCascader, advanceMultiDialog },
    props: {
        isControl: {
            type: Boolean,
            default: false
        },
        popPrefix: String,
        advancePrefix: String,
        longPrefix: String,
        moduleCode: [Number, String],
        searchTotalTitle: { // 高级-自定义搜索项
            type: Array,
            default() {
                return [];
            }
        },
        searchInitList: { // 高级列表
            type: Array,
            default() {
                return [];
            }
        },
        setSearchData: {
            type: Object,
            default() {
                return {};
            }
        },
        searchId: String,
        configurationUrl: String,
        filterable: Boolean,
        initSearchInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        pickerOptions: {
            type: Object,
            default() {
                return {};
            }
        },
        keyMaps: {
            type: Object,
            default() {
                return {};
            }
        },
        /**
         * 为 true 时 对查询条件字段值进行 trim 而不是 替换空白字符
         */
        fieldTrim: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            activeName: 'first',
            timer: null,
            searchData: {},
            searchChange: [],
            searchSetList: [],
            selectNum: [],
            showState: false,
            advanceType: 0,
            searchSetTitle: [],
            options: [],
            searchLoading: false,
            selectItem: '',
            showPopover: false,
            loading: false,
            keyMap: {},
            resourceCode: '',
            advanceMultiCache: {},
            currentAdvanceMulti: {},
            dragElData: null,
            dragEl: null
        };
    },
    methods: {
        handleItemDragStart(ev, item, key) {
            this.dragElData = { item, key };
            this.dragEl = ev.target;
            this.dragEl.classList.add('draging');
        },
        handleItemDragEnd(ev) {
            if (ev.preventDefault) {
                ev.preventDefault();
            }
            this.dragEl.classList.remove('draging');
            this.dragEl = null;
            this.dragElData = null;
        },
        handleItemDragEnter(ev, item, key) {
            if (item.value !== this.dragElData.item.value && ev.target.draggable) {
                const oldSet = [...this.searchTotalTitle];
                // unfold 的元素不能放置
                if (oldSet[key].unfold) {
                    console.log('不能放置');
                    return;
                }
                oldSet.splice(this.dragElData.key, 1);
                oldSet.splice(key, 0, this.dragElData.item);
                this.$emit('sort-search-keys', oldSet.filter(i => i.select || i.unfold).map(i => i.name).filter(Boolean));
                this.dragElData.key = key;
            }
        },

        updatePopover() {
            this.$nextTick(() => {
                this.$refs.popover.updatePopper();
            });
        },
        // input模糊搜索change，v-model无效
        handleChangeFussy(e, data, item) {
            const v = item.value + 'Fussy';
            data[v] = e;
            this.$emit('handleVagueSearch', e, v, item);
            this.handleFussyDomClass(item, e);
        },
        handleFussyDomClass(item, val) {
            const parentNodeClassList = _.get(this, `$refs.${item.value}FussyAdvancedCheckboxBtn[0].$el.parentNode.classList`);
            if (!parentNodeClassList) return;
            if (val) { // checkbox-button的checked不生效，只能动态生成和删除class，用于高级里面的模糊搜索高亮
                parentNodeClassList.add('isActive');
            } else {
                parentNodeClassList.remove('isActive');
            }
        },
        searchListChange(item, val) {
            if (item.batch) {
                val = val.replace(/\r\n/g, ',').replace(/\ +/g, ',').replace(/\n/g, ',');
                this.searchData[item.value] = val;
            }
            this.$emit('search-list-change', item, val);
        },
        // input 左边下拉框切换值
        inputSelectChange(item, searchData, val) {
            const optionItem = item.selectConfig.option.find(s => s.prop === val);
            item.placeholder = optionItem.placeholder || optionItem.label;
            searchData[item.selectConfig.prop] = val;
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.fullPath) {
                            this.resourceCode = childrens[i].resourceCode;
                            return childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        resetSearchConfig() {
            this.searchTotalTitle.map(i => {
                i.select = i.unfold;
            });
            this.selectedShow();
        },
        btnChange(index, item) {
            item.select = !item.select;
            this.searchSetList = [];
            this.selectedShow();
        },
        cancelSearch() {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
            });
            this.showState = false;
            this.showPopover = false;
        },
        showStateOpen() {
            this.showState = true;
        },
        saveSearch() {
            this.showState = false;
            this.showPopover = false;
            let searchTotalTitle = [];
            let searchTotalName = [];
            this.searchTotalTitle.filter(i => i.select || i.unfold).forEach(data => {
                searchTotalTitle.push(data.name);
                searchTotalName.push(data.value);
            });
            searchTotalTitle = searchTotalTitle.join(',');
            searchTotalName = searchTotalName.join(',');
            const pramas = {
                'configName': searchTotalName,
                'configNameCn': searchTotalTitle,
                'subjectType': this.searchId,
                'moduleCode': this.moduleCode || this.resourceCode,
                'id': this.user.employeeId
            };
            getList.post(this.configurationUrl, pramas).then(() => {
            }).catch(() => { });
        },
        clear() {
            this.searchReset(null, true);
            this.$emit('init-search', null, true);
        },
        search() {
            const searchData = _.clone(this.searchData);
            if (this.searchChange.length !== 0) {
                this.searchChange.map(item => {
                    if (item.value !== item.startValue && item.value) {
                        delete searchData[item.endValue];
                    }
                });
            }
            const setSearchData = _.clone(this.setSearchData);
            const data = Object.assign({}, setSearchData, searchData);
            this.$emit('search', data);
            this.showPopover = false;
        },
        advanceCodeChange(num, current) {
            this.advanceType = num;
            this.currentSearchData[current.advanceCode] = '';
        },
        searchReset(searchDataIn = null, reset = false) {
            const searchData = searchDataIn || {};
            if (reset) {
                this.clearAdvanceMulitCache();
            }
            // 过滤有值的属性，只对未赋值的属性进行初始化
            this.searchSetList.filter(data => !searchData[data.value]).map(data => {
                if (reset || !this.initSearchInfo[data.value]) {
                    if (data.type === 'input' && data.isFussy) {
                        this.handleFussyDomClass(data, reset ? false : searchData[data.value + 'Fussy']);
                    } else if (data.type === 'time' && data.timeNum) {
                        const today = dayjs();
                        const startOfDay = today.startOf('day');
                        const endOfDay = today.endOf('day');
                        const start = data.future ? startOfDay.toDate() : startOfDay.subtract(data.timeNum, 'd').toDate();
                        const end = data.future ? endOfDay.add(data.timeNum, 'd').toDate() : today.endOf('day').toDate();
                        searchData[data.value] = [start, end];
                    } else if (data.type === 'advance' || data.type === 'advanceMulti') {
                        if (this.keyMap[data.value]) {
                            this.keyMap[data.value].forEach(key => { searchData[key] = ''; });
                        } else {
                            searchData[data.value] = '';
                        }
                        if (data.type === 'advanceMulti') {
                            this.advanceMultiCache[data.value] = [];
                        }
                    } else {
                        let item = '';
                        if (data.data) {
                            item = data.data;
                        } else if (data.multiple) {
                            item = [];
                        }
                        let key = data.value;
                        if (data.passValue) {
                            this.searchChange.push({ startValue: data.ganged, endValue: data.value, value: data.passValue });
                            key = data.passValue;
                        }
                        searchData[key] = item;
                    }
                } else {
                    searchData[data.value] = this.initSearchInfo[data.value];
                }
            });
            this.searchData = searchData;
        },
        // 清空基础数据多选框值
        clearAdvanceMulitCache() {
            Object.keys(this.advanceMultiCache).forEach(item => {
                this.advanceMultiCache[item] = [];
            });
        },
        searchInit() {
            // 只保存弹窗上存在的元素的属性
            const searchData = this.searchSetList.map(data => {
                // 初始化keyMap
                // 保留 advance 和 advanceMulti 的返回键的值
                if ((data.type === 'advance' || data.type === 'advanceMulti') && _.isArray(data.cbParams)) {
                    const keys = data.cbParams.map(item => {
                        const arr = item.split('#');
                        return arr[1] || arr[0];
                    });
                    keys.forEach(key => {
                        this.keyMap[key] = keys;
                    });
                }
                // input select 和 模糊
                if (data.type === 'input' && (data.selectConfig || data.isFussy)) {
                    const { selectConfig } = data;
                    const key2 = data.isFussy ? data.value + 'Fussy' : selectConfig.prop;
                    const arr = [data.value, key2];
                    // 初始化
                    this.keyMap[data.value] = this.keyMap[key2] = arr;
                }
                return data.value;
            }).reduce((result, prop) => {
                if (this.keyMap[prop]) {
                    this.keyMap[prop].forEach(key => {
                        result[key] = this.searchData[key];
                    });
                } else {
                    result[prop] = this.searchData[prop];
                }
                return result;
            }, {});
            this.searchReset(searchData);
        },
        userDetaliSearch(num, current) {
            this.advanceType = num;
            this.$refs.advanceUser.show(current);
        },
        detaliSearchBlur(num, current, searchData) {
            searchData = this.trimOrReplaceSpace(searchData);
            if (searchData !== '' && !current.advanceReadonly) {
                this.detaliSearch(num, current, searchData);
            }
        },
        // 高级弹框
        detaliSearch(num, current, searchData) {
            this.advanceType = num;
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            const advanceCascade = {};
            if (_.isString(current.advanceCascade)) {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }
            // this.$refs.advanceDialog.show(true, current, advanceCascade);
            this.$refs.advanceDialog.show(true, current, advanceCascade, '', [], searchData);
        },
        detaliListSearch(num, current) {
            this.advanceType = num;
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            const advanceCascade = {};
            if (_.isString(current.advanceCascade)) {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }

            // advanceMultiCache：缓存选中数据
            this.currentAdvanceMulti = current;
            if (!this.advanceMultiCache[current.value]) this.advanceMultiCache[current.value] = [];
            const cache = this.advanceMultiCache[current.value];
            this.$refs.advanceMultiDialog.show(true, current, advanceCascade, cache.length ? cache : undefined);
        },
        detaliSearchSure(data, config) {
            // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
            const keyArr = Object.keys(data);
            if (keyArr.length > 0) {
                keyArr.forEach(key => {
                    this.keyMap[key] = keyArr;
                });
            }
            Object.assign(this.currentSearchData, data);
            this.searchListChange(config, data);
        },
        detaliListSearchSure(data, config) {
            const keyArr = Object.keys(data[0]);
            const params = {};
            keyArr.forEach(key => {
                this.keyMap[key] = keyArr;
                if (!params[key]) params[key] = [];
                data.forEach(item => {
                    params[key].push(item[key]);
                });
                params[key] = params[key].join();
            });
            Object.assign(this.searchData, params);
            Object.assign(this.currentSearchData, params);
            this.searchListChange(this.currentAdvanceMulti, params);
        },
        /** single默认为false，设为true表示主动调用 阻止死循环 */
        detailCheckedList(data, item, single) {
            this.advanceMultiCache[item.value] = data;
            this.syncAdvanceMultiData(data, item, single);
        },
        syncAdvanceMultiData(data, item, single) {
            if (item.unfold && !single) {
                this.$emit('detailCheckedList', data, item, true);
            }
        },
        getSetList() {
            const menu = { subResources: _.clone(this.menus) };
            this.deepMenu(menu);
            let checkedList = '';
            const pramas = {
                subjectType: this.searchId,
                moduleCode: this.moduleCode || this.resourceCode,
                id: this.user.employeeId
            };
            return getList.get(this.configurationUrl, pramas).then(data => {
                if (data.data) {
                    checkedList = data.data.configNameCn;
                    this.searchSetTitle = checkedList.split(',');
                    this.$emit('sort-search-keys', this.searchSetTitle);
                } else {
                    this.searchSetTitle = [];
                }
            }).catch(() => {
                this.searchSetTitle = [];
            });
        },
        creatSearchList() {
            this.searchSetList = this.searchTotalTitle.map(item => {
                item.select = this.searchSetTitle.includes(item.name);
                return item;
            }).filter(item => item.select);
        },
        getRemoteMethod(query) {
            this.options = [];
            let searchData;
            if (query) {
                searchData = this.trimOrReplaceSpace(query);
            } else {
                searchData = '';
            }
            const params = {
                [this.selectItem.tableName]: {
                    [this.selectItem.value]: searchData,
                    [this.selectItem.ganged]: searchData
                }
            };
            if (this.selectItem.relevanceOne) {
                const temp = this.selectItem.relevanceOnePlace || this.selectItem.relevanceOne;
                params[this.selectItem.tableName][temp] = Array.isArray(this.setSearchData[this.selectItem.relevanceOne])
                    ? this.setSearchData[this.selectItem.relevanceOne].join(',') : this.setSearchData[this.selectItem.relevanceOne];
            }
            if (this.selectItem.relevanceTwo) {
                const temp = this.selectItem.relevanceTwoPlace || this.selectItem.relevanceTwo;
                params[this.selectItem.tableName][temp] = Array.isArray(this.setSearchData[this.selectItem.relevanceTwo])
                    ? this.setSearchData[this.selectItem.relevanceTwo].join(',') : this.setSearchData[this.selectItem.relevanceTwo];
            }
            longRange(this.longPrefix, params).then(data => {
                const restaurants = [];
                data.data[this.selectItem.tableName].map(search => {
                    restaurants.push({
                        'value': search[this.selectItem.ganged],
                        'label': search[this.selectItem.value],
                        'passValue': search[this.selectItem.autocompExtra],
                        'id': search[this.selectItem.uniqueID || 'id']
                    });
                });
                this.searchLoading = true;
                setTimeout(() => {
                    this.searchLoading = false;
                    const options = restaurants.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(searchData.toLowerCase()) > -1;
                    });
                    this.$nextTick(() => {
                        this.$set(this.selectItem, 'options', options);
                    });
                }, 20);
            });
        },
        remoteMethod(query) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.getRemoteMethod(query);
            }, 300);
        },
        searchDateChange(item) {
            this.selectItem = item;
            this.remoteMethod();
        },
        getOptionList() {
            this.searchTotalTitle.map(columns => {
                if (columns.optionNum) {
                    const params = {
                        dictCodes: columns.optionNum,
                        tenantCode: this.currentTenant.tenantCode
                    };
                    dict(this.popPrefix, params).then(data => {
                        const option = [];
                        for (const key in data.data[columns.optionNum]) {
                            if (data.data[columns.optionNum].hasOwnProperty(key)) {
                                option.push({ 'value': key, 'label': data.data[columns.optionNum][key] });
                            }
                        }
                        columns.options = option;
                    });
                }
            });
        },
        initData() {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
                this.showState = false;
                this.keyMap = this.keyMaps;// 关联keyMap 实现清除
            });
        },
        initInputSelect(item) {
            const { selectConfig } = item;
            this.searchData[selectConfig.prop] = selectConfig.value;
        },
        selectedShow() {
            const searchSetList = [];
            this.searchTotalTitle.map((data, index) => {
                if (data.type === 'input' && data.selectConfig) {
                    this.initInputSelect(data);
                }
                if (data.select) {
                    searchSetList.push(data);
                }
            });
            this.searchSetList = searchSetList;

            this.searchInit();
            this.$forceUpdate();
            this.$emit('updateView', searchSetList.map(i => i.value));
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams(item) {
            if (item.disabled) return;
            const prop = item.value;
            const keyArr = this.keyMap[prop];
            // 把属性相关联的字段置空
            if (item.advanceReadonly) {
                this.currentSearchData[prop] = '';
            } else {
                keyArr.forEach(key => {
                    this.currentSearchData[key] = '';
                });
            }
            if (this.advanceMultiCache[prop]) {
                this.advanceMultiCache[prop] = [];
            }
            if (item.unfold && item.type === 'advanceMulti') {
                this.syncAdvanceMultiData([], item);
            }
        },
        changeLoading(status) {
            this.loading = status;
        },
        trimOrReplaceSpace(str) {
            if (this.fieldTrim) {
                return (str || '').trim();
            } else {
                return (str || '').replace(/\s*/g, '');
            }
        }
    },
    created() {
        this.getOptionList();
        this.$eventBus.$on(this.$route.name, () => {
            this.showPopover = false;
        });
    },
    mounted() {
        this.initData();
    },
    watch: {
        searchTotalTitle: {
            handler(val) {
                if (val.length) {
                    this.activeName="first"
                }else {
                    this.activeName="second"
                }
            },
            // deep: true,
            immediate: true
        }
    },
    computed: {
        ...mapGetters(['currentTenant', 'menus', 'user']),
        _() {
            return _;
        },
        searchList() {
            return [
                {
                    list: this.searchInitList,
                    data: this.setSearchData
                },
                {
                    list: this.searchSetList,
                    data: this.searchData
                }];
        },
        currentSearchData() {
            return this.advanceType === 0 ? this.setSearchData : this.searchData;
        }
    }
};

</script>
<style lang="less">
.search-list-btn {
    text-align: left;
}

#search-set-v2 {
    .el-range-separator {
        width: 16px;
    }

    .overflow-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .el-input__inner {
        height: 28px !important;
        padding: 3px 25px;
    }

    ul {
        display: flex;
        flex-wrap: wrap;
    }

    .el-input-group__prepend {
        .el-select {
            width: 60px;
        }

        .el-input__inner {
            padding: 3px 16px 3px 5px;
        }

        .el-input__suffix {
            right: 2px;
        }
    }

    .el-icon-circle-plus{
        cursor: pointer;
    }
    .el-icon-error{
        cursor: pointer;
    }

    .is-unselect {
        background: #f2f2f2;
        &:hover{
            border-color: #b3ebec;
        }
    }
    .is-disabled {
        opacity: 0.5;
    }
    .is-select {
        &.el-button,
        &.el-button.is-disabled,
        &.el-button.is-disabled:hover,
        &.el-button.is-disabled:focus {
            color: #555757;
            border-color: #CECECE;
        }

        &.el-button {
            background: #fff;
        }
    }

    .btn-icon {
        position: absolute;
        right: 3px;
        top: -6px;
        color: #00BCBF;
    }

    .el-icon-circle-check {
        color: #C3C7C7;
        display: none;
    }

    .el-icon-circle-check:hover {
        cursor: not-allowed;
    }

    .el-icon-error {
        color: #FF3300;
    }

    .search-list-box {
        margin-top: 10px;
        max-height: 42vh;
        overflow-y: scroll;

        >li {
            margin-bottom: 10px;
            display: flex;

            >.label {
                display: inline-block;
                height: 28px;
                line-height: 28px;
                width: 420px;
                padding: 0 10px 0 0;
                text-align: right;
            }

            >.form-item {
                width: 320px;

                >div {
                    width: 100%;
                }
            }

            .select-btn {
                color: #eee !important;
            }

            &.is-fussy {
                .label {
                    width: 110px;
                }

                .el-input-group--append {
                    .el-input-group__append {
                        background-color: #fff;
                    }

                    .isActive {
                        background-color: #00BCBF;
                        color: #fff;
                    }
                }

                .form-item {
                    width: 290px;
                }

                .input-append-fussy {
                    width: 48px;
                    margin-top: 4px;
                    margin-left: 6px;

                    .el-checkbox__label {
                        padding-left: 4px;
                    }
                }
            }
        }
    }

    .line {
        height: 1px;
        width: 100%;
        background-color: #F2F2F2;
    }

    .search-total-box {
        max-height: 420px;
        overflow: auto;

        >div {
            padding: 0 10px 10px 0;
        }
    }

    .btn-box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding-top: 4px;

        .text-btn {
            width: 40%;
        }

        .btn-btn {
            width: 60%;
            display: flex;
            justify-content: flex-end;
        }
    }

    .btn-width {
        width: 100%;

    }

    .text-box {
        position: relative;
        font-size: 12px;
        width: 100%;
    }

    .v-modal {
        z-index: 2000 !important;
    }
}

.relative {
    position: relative;
}

.search-set_back {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    // opacity: 0.5;
    // background: #000000;

}
</style>
